import type {
    ExternalListsClientInterface,
    ExternalListsContactCountParams,
    ExternalListsAttributesParams,
    ExternalListsGroupCountParams,
    GetExternalListsParams,
    ExternalListTemplateConfigPayload,
} from './externalListsClient.types';
import BaseClient from '../BaseClient';

export default class CorporateExternalListsClient extends BaseClient implements ExternalListsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getExternalLists(params?: GetExternalListsParams) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsCount(params?: GetExternalListsParams) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsContactCount(params: ExternalListsContactCountParams) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/contact-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsAttributes(params: ExternalListsAttributesParams) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/attributes`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsGroupCount(params: ExternalListsGroupCountParams) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/group-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListTemplateConfig(externalListId: number) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/${externalListId}/template-config`;
        return this.makeCoreApiRequest(url, 'get');
    }

    upsertExternalListTemplateConfig(externalListId: number, data: ExternalListTemplateConfigPayload) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/${externalListId}/template-config`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteExternalListTemplateConfig(externalListId: number) {
        const url = `/api/v3/teams/${this.teamId}/external-contact-lists/${externalListId}/template-config`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}
